import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Show } from '../models/show';

@Injectable({ providedIn: 'root' })
export class HotBackend {
  private readonly http = inject(HttpClient);

  getShows(): Observable<Show[]> {
    return this.http.get<Show[]>(`${environment.apiBaseUrl}/v1/show`);
  }
}
